export const ACTIONS_INSALES = {
  ADD_PRODUCTS: 'ADD_INSALES_PRODUCTS',
  CHANGE_PRODUCT: 'CHANGE_INSALES_PRODUCT',
  CHANGE_MARKET: 'CHANGE_INSALES_MARKET',
};

export const addInsalesProducts = data => ({
  type: ACTIONS_INSALES.ADD_PRODUCTS,
  data,
});

export const actionChangeInsalesProduct = (product = {}) => ({
  type: ACTIONS_INSALES.CHANGE_PRODUCT,
  product,
});

export const changeInsalesMarket = market => ({
  type: ACTIONS_INSALES.CHANGE_MARKET,
  market,
});